module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "talion-view"
  }, [_c('div', {
    staticClass: "header-bar"
  }, [_c('span', {
    staticClass: "close-talion",
    on: {
      "click": _vm.closeTalion
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('form', {
    staticClass: "search",
    attrs: {
      "onsubmit": "return false"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim.lazy",
      value: (_vm.queryStr),
      expression: "queryStr",
      modifiers: {
        "trim": true,
        "lazy": true
      }
    }],
    attrs: {
      "type": "search",
      "name": "query"
    },
    domProps: {
      "value": (_vm.queryStr)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.goSearch()
      },
      "change": function($event) {
        _vm.queryStr = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('sub-nav', {
    attrs: {
      "mold": "navBottom"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "has-header"
  }, [_c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(35, 132, 232)"
    }
  }, [_vm._v("电影")]), _vm._v(" "), _c('span', [_vm._v("影院热映")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(230, 70, 126)"
    }
  }, [_vm._v("同城")]), _vm._v(" "), _c('span', [_vm._v("周末活动")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(159, 120, 96)"
    }
  }, [_vm._v("阅读")]), _vm._v(" "), _c('span', [_vm._v("电子书")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(225, 100, 77)"
    }
  }, [_vm._v("东西")]), _vm._v(" "), _c('span', [_vm._v("心爱之物")])])])]), _vm._v(" "), _c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(122, 106, 219)"
    }
  }, [_vm._v("电视")]), _vm._v(" "), _c('span', [_vm._v("正在热播")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(42, 184, 204)"
    }
  }, [_vm._v("小组")]), _vm._v(" "), _c('span', [_vm._v("志趣相投")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(87, 116, 197)"
    }
  }, [_vm._v("游戏")]), _vm._v(" "), _c('span', [_vm._v("虚拟世界")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(64, 207, 169)"
    }
  }, [_vm._v("FM")]), _vm._v(" "), _c('span', [_vm._v("红心歌单")])])])]), _vm._v(" "), _c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(159, 120, 96)"
    }
  }, [_vm._v("图书")]), _vm._v(" "), _c('span', [_vm._v("畅销排行")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(244, 143, 46)"
    }
  }, [_vm._v("音乐")]), _vm._v(" "), _c('span', [_vm._v("新碟榜")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(89, 108, 221)"
    }
  }, [_vm._v("应用")]), _vm._v(" "), _c('span', [_vm._v("玩手机")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(66, 189, 86)"
    }
  }, [_vm._v("市集")]), _vm._v(" "), _c('span', [_vm._v("购买原创")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-045ebeb4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/TalionView.vue
// module id = 184
// module chunks = 0